module.exports = __webpack_public_path__ + "static/media/apple_podcasts.7f2c29f8.png";